import React from 'react';

import { Product } from 'api/types/product';
import ProductsList from '../ProductsList';
import { ProductLocalStatus } from 'utils/product';

import './MyProducts.scss';

export interface IMyProducts {
  data: Product[];
  openedProductId?: number;
  storeId: number;
  newLocalProducts: Record<string, ProductLocalStatus>;
  productsAreReordering: boolean;
  onEdit: (product: Partial<Product>) => void;
  onDelete: (product: Partial<Product>) => void;
  onPreview: (product: Partial<Product>) => void;
  updateStoreProducts: () => void;
  currency?: string;
  onPropagate?: (product: Partial<Product>) => void;
  onMassDelete?: (product: Partial<Product>) => void;
}

const MyProducts = ({
  data,
  openedProductId,
  storeId,
  newLocalProducts,
  productsAreReordering,
  onEdit,
  onDelete,
  onPreview,
  updateStoreProducts,
  currency,
  onPropagate,
  onMassDelete,
}: IMyProducts) => (
  <div className="DashboardStore_MyProducts">
    <ProductsList
      data={data}
      currency={currency}
      openedProductId={openedProductId}
      onEdit={onEdit}
      onDelete={onDelete}
      onPreview={onPreview}
      onPropagate={onPropagate}
      onMassDelete={onMassDelete}
      newLocalProducts={newLocalProducts}
      storeId={storeId}
      updateStoreProducts={updateStoreProducts}
      productsAreReordering={productsAreReordering}
    />
  </div>
);

export default MyProducts;
